var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"csp csp-word-text"},[(!_vm.titleHide)?_c('SubHeaderNew',{attrs:{"title":_vm.title}}):_vm._e(),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.content)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }